import { FC } from 'react';
import cx from 'classnames';
import { Link, useMatch, useResolvedPath } from 'react-router-dom';

import { SvgIcon } from '@/components';

import styles from './SidebarNavLink.module.sass';

interface SidebarNavLinkProps {
  iconName?: string;
  text: string;
  to: string;
  className?: string;
}

const SidebarNavLink: FC<SidebarNavLinkProps> = ({
  iconName,
  text,
  to,
  className,
}) => {
  const resolved = useResolvedPath(to);
  const matched = useMatch({ path: resolved.pathname });

  const classes = cx(
    styles.link,
    {
      [styles['is-active']]: matched,
      [styles['is-no-icon']]: !iconName,
    },
    className,
  );

  return (
    <Link className={classes} to={to}>
      {iconName && <SvgIcon name={iconName} className={styles.icon} />}
      <span className={styles.text}>{text}</span>
    </Link>
  );
};

export default SidebarNavLink;
